import * as React from "react";

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-4uxqju-MuiSvgIcon-root"
    data-testid="ScheduleIcon"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      strokeWidth="1.25008"
      fillRule="evenodd"
      d="M8.875 2.624A.625.625 0 0 1 9.5 2h5a.625.625 0 1 1 0 1.25h-5a.625.625 0 0 1-.625-.625Zm.75 16.877h4.75l2 2.5h1.875l-2.253-2.818a2.5 2.5 0 0 0 1.05-1.134l1.407-3.045a7.5 7.5 0 0 0 .531-4.7l-.73-3.456a3.75 3.75 0 0 0-3.67-2.974h-5.17a3.75 3.75 0 0 0-3.67 2.976l-.73 3.454a7.5 7.5 0 0 0 .53 4.7l1.408 3.045a2.5 2.5 0 0 0 1.05 1.134L5.75 22.001h1.875Zm-.438-4.376a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875zm4.688.938a.938.938 0 1 1 1.875 0 .938.938 0 0 1-1.875 0zM8.967 5.75a1.25 1.25 0 0 0-1.246 1.338l.416 5.843a.681.681 0 0 0 .493.607 12.266 12.266 0 0 0 6.74 0 .681.681 0 0 0 .493-.608l.417-5.842a1.25 1.25 0 0 0-1.247-1.338Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgComponent;
